import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../../shared/shared.module';
import { InlineEditModule } from '../../shared/inline-edit/inline-edit.module';
import { ScreenTalentComponent } from './screen-talent.component';
import { TestsComponent } from './tests/tests.component';
import { TestFormComponent } from './test-form/test-form.component';
import { TestComponent } from './test/test.component';
import { PendingComponent } from './test/pending/pending.component';
import { CompletedComponent } from './test/completed/completed.component';
import { SummaryComponent } from './test/summary/summary.component';
import { KnowledgeComponent } from './test/summary/knowledge/knowledge.component';
import { CodingComponent } from './test/summary/coding/coding.component';
import { HackarootComponent } from './test/summary/hackaroot/hackaroot.component';
import { ProjectUploadComponent } from './test/summary/project-upload/project-upload.component';
import { ProjectComponent } from './test/summary/project/project.component';
import { DiagramComponent } from './test/summary/diagram/diagram.component';
import { WebComponent } from './test/summary/web/web.component';
import { LibraryComponent } from './test/summary/library/library.component';
import { LibraryComponent as KnowledgeLibrary } from './test/summary/knowledge/library/library.component';
import { LibraryComponent as CodingLibrary } from './test/summary/coding/library/library.component';
import { LibraryComponent as HackarootLibrary } from './test/summary/hackaroot/library/library.component';
import { LibraryComponent as ProjectUploadLibrary } from './test/summary/project-upload/library/library.component';
import { LibraryComponent as ProjectLibrary } from './test/summary/project/library/library.component';
import { LibraryComponent as DiagramLibrary } from './test/summary/diagram/library/library.component';
import { LibraryComponent as WebLibrary } from './test/summary/web/library/library.component';
import { InviteCandidateComponent } from './test/invite-candidate/invite-candidate.component';

// modals
import { ViewKnowledgeLibraryModalComponent } from './test/summary/knowledge/library/view/view.component';
import { ViewCodingChallengeModalComponent } from './test/summary/coding/library/view/view.component';
import { ViewHackarootChallengeModalComponent } from './test/summary/hackaroot/library/view/view.component';
import { ViewProjectUploadChallengeModalComponent } from './test/summary/project-upload/library/view/view.component';
import { ViewProjectChallengeModalComponent } from './test/summary/project/library/view/view.component';
import { ViewDiagramChallengeModalComponent } from './test/summary/diagram/library/view/view.component';
import { ViewWebChallengeModalComponent } from './test/summary/web/library/view/view.component';

import { ScreenTalentService } from './screen-talent.service';
import { ClientRouteResolve } from '../../../providers/client-route-resolve.service';

import { TagifyComponent } from './test/invite-candidate/tagify.component';
import { SortablejsModule } from 'angular-sortablejs';
import { ShowdownModule } from '../shared/components/showdown.module';
import { CodeSampleModule } from '../shared/components/code-sample.module';

import { routing } from './screen-talent.routing';


export class ScreenTalentModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/screen-talent.module.ts